export default "__VITE_ASSET__CZPcBVnk__"